
import {Vue, Component, Prop} from 'vue-property-decorator';

import {materiaApi, classesApi} from '@/api';

@Component({})
export default class course_card extends Vue {
    //===================================data区域begin
    @Prop(Object) courseList!: Object | undefined;
    schoolId: string = '';
    isfold: boolean = true;
    coursesList: any = [];
    //===================================data区域end
    //===================================computed区域begin
    //===================================computed区域end
    //===================================methods区域begin
    onSearch(value: any) {
        // console.log(value);
        for (let i = 0; i < this.coursesList.courses.length; i++) {
            let book = this.coursesList.courses[i];
            book.matched = true;
            if (value && book.name.indexOf(value) < 0) {
                book.matched = false;
            }
        }
    }
    switchFold(item: any, index: any) {
        if (this.isfold == true) {
            this.isfold = false;
            item.isShowFold = false;
        } else {
            this.isfold = true;
            item.isShowFold = true;
        }
    }
    // 获取课程数据
    getCourseList() {
        let me = this;
        let courseIds = [];
        let courseInfo = me.courseList as any;
        if (courseInfo.isCopy) {
            courseIds = courseInfo.appClassCourseIds;
        } else {
            courseIds = courseInfo.classCoursIds;
        }
        let urlQueryParmas = {
            courseIds: courseIds
        };
        materiaApi.CourseIdListInfo({
            context: me,
            urlQueryParmas: urlQueryParmas,
            success(data: any) {
                // console.log(data);
                for (let i = 0; i < data.data.courses.length; i++) {
                    if (data.data.courses[i].phases[0] == 'primary') {
                        data.data.courses[i].phases[0] = '小学';
                    } else if (data.data.courses[i].phases[0] == 'junior') {
                        data.data.courses[i].phases[0] = '初中';
                    } else if (data.data.courses[i].phases[0] == 'senior') {
                        data.data.courses[i].phases[0] = '高中';
                    }
                    data.data.courses[i].matched = true;
                    if (data.data.courses[i].introduction?.length > 14) {
                        data.data.courses[i]['isShowFold'] = true;
                    }
                    data.data.courses[i].classNum = 1;
                }
                me.coursesList = data.data;
                me.getList();
            },
            error(error: any, message: string) {
                me.$message.error(message);
            }
        });
    }
    // 获取班级数量
    getList() {
        let me = this;
        let schoolIdList = [];
        schoolIdList.push(me.schoolId);
        let data: any = {
            schoolIdList: [schoolIdList]
        };
        materiaApi.getListV2({
            context: me,
            data: data,
            success(data: any) {
                let objectList = data.data;
                // console.log(me.coursesList.courses, objectList);
                me.coursesList.courses.forEach((item: any) => {
                    objectList.forEach((el: any) => {
                        if (item.courseId == el.courseId) {
                            item.classNum = el.numberOfAssociatedClass;
                        }
                    });
                });
                // console.log(me.coursesList.courses);
            },
            error(error: any, message: string) {
                me.$message.error(message);
            }
        });
    }
    //===================================methods区域end
    created() {
        let value = window.localStorage.getItem('aicp_school_materials_$state_aicp_school_materials');
        this.schoolId = JSON.parse(value as string).schoolId;
        // console.log(this.courseList);

        this.getCourseList();
    }
}
